// Module
var code = "<div ng-if=\"initialized\"> <remote-paged-grid-layout title-label-code=\"'customers'\" new-entity-label-code=\"'new.customer'\" columns=\"columns\" find-page=\"findPage\" filter-select=\"filterSelect\" sort-info=\"sortInfo\"> </remote-paged-grid-layout> </div> ";
// Exports
export default code;